<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";
import serviesDetailsView from "./actions/ServiesDetails.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
    serviesDetailsView,
  },
  created() {
    this.$store.dispatch("lookups/getDepartments");

    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.services.totalItems / this.filters.pageSize
      );
    },
    services() {
      return this.$store.state.services.services;
    }, departments() {

      return [{
        value: 0, label: "الكل"
      }, ...this.$store.state.lookups.departments];
    },

  },

  data() {
    return {
      permissions: this.$settingPermissions.ServicesPermissions,

      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        departmentId: 0,
        serviceName: null,
      },
      headers: [
        { text: 'اسم الخدمة', value: 'serviceName' },
        { text: 'القسم ', value: 'departmentName' },
        { text: 'السعر', value: 'price' },
        { text: 'عدد الخدمات التفصلية ', value: 'servicesDetailsCount' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      // services: [
      //   { label: 1, serviceName:"خدمة 1", price:"20.0 د", roomNo:"الغرفة 1" }
      // ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("services/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    }, 
    serviesDetailsView(item) {
      this.itemId = item.id;
      this.view = 4;
      // Implement edit logic
    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف الخدمة";
          break;


      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {

      this.$store.dispatch(`services/${this.dialogType}`, this.itemId);

      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>